// Importing action types, URLs, and helper functions
import * as types from "./ActionTypes"; // Importing action type constants
import * as urls from "../../Uintls/Urls"; // Importing API endpoint URLs
import { get } from "../Helper/index"; // Importing a helper function for GET requests

// Action to reset the Redux reducer state
export const resetReducer = () => ({
  type: types.REST_REDUCER_STATE, // Dispatches the action type to reset the reducer state
});

// Action to fetch the default theme configuration
export const defaultThemeCall = () => dispatch => {
  // Dispatch an action to indicate the default theme call has started
  dispatch({ type: types.DEFAULT_THEME_CALL });

  // Make a GET request to fetch the default theme configuration
  get({
    url: `${urls.DEFAULT_THEME_CALL}`, // API endpoint for fetching the default theme
    success: types.DEFAULT_THEME_SUCCESS, // Action type for a successful response
    failure: types.DEFAULT_THEME_ERROR, // Action type for a failed response
    dispatch, // Dispatch function to send actions to the Redux store
    body: "default", // Optional body parameter for the request
  });
};

// Action to handle initial data loading
export const handleInitialData = () => async dispatch => {
  // Dispatch the default theme call as part of the initial data loading process
  dispatch(defaultThemeCall());
};
